module.exports = __webpack_public_path__ + "img/hack-vc.b2d3aad4.svg";